import { inject } from 'aurelia';
import { Helper } from './../resources/extensions/helper';
import { ApiService } from './api-service';
import { websiteShortCode } from '../environment';

@inject(ApiService, Helper)
export class LanguageWebsiteService {
    path = 'LanguageWebsite';
    languages: { availableWebsites: string[], language: { id: number, name: string, imagePath: string, hrefLang: string }, position: number, live: boolean, websiteId: number, languageId: number }[] | null = null;

    constructor(private api: ApiService, private helper: Helper) {
        this.api = api;
        this.helper = helper;
    }

    async getByWebsite() {
        return this.helper.handlePendingRequest(this, async() => {
            if (this.languages) return this.languages;
            this.languages = await this.api.doGet(`${this.path}/ByWebsite?websiteShortCode=${websiteShortCode()}`);
            return this.languages?.sort((a, b) => {
                return ((b.position !== null) - (a.position !== null) || a.position - b.position) || a.language?.name?.localeCompare(b.language.name);
            });
        });
    }
}
